import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { device, merchantThemes } from 'components/Variable'

export const OrderItemStyle = styled.div`
	position: relative;
	margin-bottom: ${rem(20)};
	border-radius: ${rem(8)};
	overflow: hidden;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			border: ${rem(1)} solid ${({ theme }) => theme.color.blackOne};
		`}
`
export const Header = styled.div`
	display: flex;
	align-items: center;
	padding: ${rem(15, 22)};
	background-color: ${({ theme }) => theme.color.secondary};
	color: ${({ theme }) => theme.color.blackOne};
	cursor: pointer;
	transition: all 0.3s;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			background-color: transparent;
		`}

	@media (${device.tablet}) {
		background-color: ${({ theme }) => theme.color.blackOne};
		color: ${({ theme }) => theme.color.secondary};
	}

	${(p) =>
		p.isOpen &&
		css`
			background-color: ${({ theme }) => theme.color.primary}!important;
			color: ${({ theme }) => theme.color.secondary}!important;

			${(p) =>
				p.theme.name === merchantThemes.toteme &&
				css`
					background-color: ${({ theme }) =>
						theme.color.secondary}!important;
					color: ${({ theme }) => theme.color.blackOne}!important;
					border-bottom: ${rem(1)} solid
						${({ theme }) => theme.color.primary};
				`}
		`}

	& > div {
		&:nth-child(1),
		&:nth-child(3) {
			flex: 1 0;
		}
	}
`

export const OrderId = styled.div`
	font-weight: 700;
	font-size: ${rem(18)};
	line-height: ${rem(25)};
	letter-spacing: ${rem(0.257143)};
	margin-bottom: ${rem(6)};
	display: flex;
	align-items: center;
	white-space: nowrap;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
			font-size: ${rem(15)};
			letter-spacing: ${rem(0.06)};
		`}

	@media (${device.tablet}) {
		font-size: ${rem(14)};
		line-height: ${rem(18)};
	}
	svg {
		margin-left: ${rem(10)};
		@media (${device.tablet}) {
			fill: ${({ theme }) => theme.color.secondary};
			width: ${rem(15)};
			height: ${rem(15)};
			margin-left: ${rem(5)};
		}
		${(p) =>
			p.isOpen &&
			css`
				fill: ${({ theme }) => theme.color.secondary};
			`}
	}
`
export const OrderDate = styled.div`
	font-weight: 600;
	font-size: ${rem(14)};
	line-height: ${rem(19)};
	letter-spacing: ${rem(0.2)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
			letter-spacing: ${rem(0.06)};
			font-size: ${rem(15)};
		`}

	@media (${device.tablet}) {
		font-size: ${rem(12)};
		line-height: ${rem(16)};

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				line-height: ${rem(20)};
				letter-spacing: ${rem(0.06)};
				font-size: ${rem(15)};
			`}
	}
`
export const OrderShipment = styled.span`
	color: ${({ theme }) => theme.color.redOne};
	display: inline-block;
	white-space: nowrap;
	@media (${device.tablet}) {
		display: none;
	}
`
export const Arrow = styled.div`
	width: ${rem(40)};
	height: ${rem(40)};
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${({ theme }) => theme.color.graySeven};
	cursor: pointer;
	transition: all 0.3s;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			background-color: transparent;
		`}

	@media (${device.tablet}) {
		width: ${rem(26)};
		height: ${rem(26)};
	}
	svg {
		width: 40%;
		height: 40%;
	}
	${(p) =>
		p.isOpen &&
		css`
			background-color: ${({ theme }) => theme.color.secondary};
			transform: rotate(-180deg);

			${(p) =>
				p.theme.name === merchantThemes.toteme &&
				css`
					background-color: transparent;
				`}
		`}
`
export const OrderPrice = styled(OrderId)`
	text-align: right;
	display: block;
`
export const OrderQuantity = styled(OrderDate)`
	text-align: right;
`
export const Body = styled.div`
	position: relative;
	overflow: hidden;
	overflow-y: auto;
	transition: all 0.3s;
	height: 0;
	${(p) =>
		p.isOpen &&
		css`
			height: auto;
		`}
`
export const Status = styled.div`
	font-style: italic;
	font-size: ${rem(14)};
	line-height: ${rem(19)};
	letter-spacing: ${rem(0.2)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			line-height: ${rem(20)};
			letter-spacing: ${rem(0.06)};
			font-size: ${rem(15)};
		`}

	@media (${device.tablet}) {
		display: none;
	}
`
export const OrderText = styled.span`
	margin-right: ${rem(4)};
	@media (${device.mobileL}) {
		display: none;
	}
`
